import type { Person } from "../../api/types";

// filterPeopleByQuery keeps the people whose name or email contains the query,
// case-insensitively; a blank query keeps everyone.
export function filterPeopleByQuery(people: Person[], query: string): Person[] {
  const needle = query.trim().toLowerCase();
  if (needle === "") {
    return people;
  }
  return people.filter(
    (person) => person.user.name.toLowerCase().includes(needle) || person.user.email.toLowerCase().includes(needle)
  );
}
